import React from 'react';

import { StoreAppAPI } from '../../../core/src/storeapp-api-client';
import { EtrAPI } from '../../../core/src/etr-api-client';
import SeoMeta from '../../../page/components/seo-meta';
import { withError } from '../../../shared/components/error-boundary';
import Link from '../../../shared/components/hyperlink';
import PDPMainBlock from '../pdp-main-block';
import CategorizedAccCarousel from '../pdp-cat-acc-carousel';
import { ProductProvider, defaultContext as DefaultProductContext } from '../../../context/product/product-context';
import withWindowResize from '../../../ui/components/window-resize';

import './mmd.less';

const storeAppAPI = new StoreAppAPI();

const transformCompatData = (compatData) => {
    const {
        compatibleData = [],
        productNumber: sku,
        productName: name,
        thumbImage,
        productImage,
    } = compatData;

    return {
        product: {
            _id: sku,
            sku,
            name,
            attributes: {
                hideSpecsTab: true,
            },
            images: [
                {
                    sm: thumbImage,
                    lrg: productImage,
                },
            ],
            rating: 0,
            numReviews: 0,
            xsell: [],
            error: !name && compatibleData.length === 0,
            prdClass: 'MMD',
            slug: `${sku}`
        },
        compatibleSkus: compatibleData.map((c) => c.compatible_ProductNumber),
    };
};

class MMD extends React.Component {
    state = {
        ...DefaultProductContext,
        product: {
            attributes: {
                hideSpecsTab: true,
            },
            rating: 0,
            numReviews: 0,
            xsell: [],
            images: [],
        },
    };

    componentDidMount() {
        const { match, search } = this.props;
        const { params } = match;
        //decode to avoid double encoding
        let compatSku = decodeURIComponent(params.sku || search.sku);
        this.fetchCompatProducts(compatSku);
    }

    componentDidUpdate(prevProps, prevState) {
        const { match, search } = this.props;
        const { params } = match;
        //decode to avoid double encoding
        let compatSku = decodeURIComponent(params.sku || search.sku);
        const { match: oMatch, search: oSearch } = prevProps;
        const { params: oParams } = oMatch;
        let oCompatSku = decodeURIComponent(oParams.sku || oSearch.sku);
        if(compatSku !== oCompatSku) {
           this.fetchCompatProducts(compatSku)
        }
    }

    componentDidUpdate() {}

    fetchCompatProducts = (compatSku) => {
        EtrAPI.compatData
            .get(compatSku)
            .then((compatData) => {
                if (compatData.status == 'SUCCESS') {
                    let productData = transformCompatData(compatData);
                    const { compatibleSkus } = productData;
                    this.setState(productData);
                    if (compatibleSkus.length > 0) {
                        storeAppAPI.product
                            .search({
                                sku: compatibleSkus.slice(0, 100).join(','),
                                populate: 'categories:displayName+location+tags',
                            })
                            .then(({ data = {} }) => {
                                const { product } = this.state;
                                const xsell = data.result || [];
                                this.setState({ product: {...product, xsell }});
                            });
                    }
                    this.props.receivePDPInfo(productData.product);
                } else {
                    this.setState({ product: { error: true }});
                }
            })
            .catch(() => {
                this.setState({ product: { error: true } });
            });
    };

    render() {
        const { product } = this.state;
        const { device } = this.props;
        return (
            <div className="mmd pdp-main-block">
                <SeoMeta
                    seo={{
                        title: `HP Manage MY Device |  ${
                            product.sku ? product.sku : ''
                        }`,
                        robots: true,
                    }}
                />
                {product.error ? (
                    <div className="mmd-error">
                        Product information and associated accessories are
                        currently unavailable. Please check back later.{' '}
                        <Link to={`${process.env.BASENAME}/plp/accessories`}>Here</Link> is a link to
                        our accessories category page.
                    </div>
                ) : (
                    product.name ? <ProductProvider productContext={{ ...this.state, device }}>
                        <PDPMainBlock />
                        <CategorizedAccCarousel
                            isActive={product.xsell.length > 0}
                            product={product}
                        />
                    </ProductProvider> : null
                )}
            </div>
        );
    }
}

export default withError(withWindowResize(MMD));
